import { jsx as _jsx } from "react/jsx-runtime";
import { CardholdersScreen } from '../../../typings';
import { translate } from '../../../strings/i18n';
import { Footer, FooterWrapper } from './subcomponents';
import triggerManageCardHoldersAnalytics from '../../../helpers/trigger-manage-card-holders-analytics';
import triggerManageCardHoldersSamsAnalytics from '../../../helpers/trigger-manage-card-holders-sams-analytics';
import { PAGE_NAME, SAMS_PAGE_NAME } from '../../../const/analytics';
const CardHoldersFooter = ({ changeScreen, currentScreen, handleAddAuthUserSubmit, handleClose, usersLimit, isSamsClient = false }) => {
    const backToAccountServicesText = translate('button.backToAccountServices');
    const addAuthorizedUserText = translate('button.addAuthorizedUser');
    const addAsAnAuthorizedUserText = translate('addAuthUserScreen.addAsAnAuthorizedUser');
    const DATA_PRIMARY_TYPE = 'add authorized user';
    const DATA_SECONDARY_TYPE = 'back to account services';
    const DATA_PRIMARY_MCH_TYPE = 'back to manage cardholders';
    const DATA_OBJECT = 'button';
    const addAuthUsersAllowed = {
        handlePrimaryButton: () => {
            if (isSamsClient) {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.SELECTION
                });
                changeScreen({ screen: CardholdersScreen.ADD_AUTH_USER_SAMS_LIST });
            }
            else {
                triggerManageCardHoldersAnalytics({
                    pageName: PAGE_NAME.ADDITION
                });
                changeScreen({ screen: CardholdersScreen.ADD_AUTH_USER });
            }
        },
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryType: DATA_PRIMARY_TYPE,
        primaryText: addAuthorizedUserText,
        handleSecondaryButton: handleClose,
        dataSecondaryObject: DATA_OBJECT,
        dataSecondaryType: DATA_SECONDARY_TYPE,
        secondaryButtonType: 'ghost',
        secondaryText: backToAccountServicesText
    };
    const backToAccountServicesPrimary = {
        primaryText: backToAccountServicesText,
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryType: DATA_SECONDARY_TYPE,
        handlePrimaryButton: handleClose
    };
    const backToManageCardholdersPrimary = {
        primaryText: translate('button.backToManageCardholders'),
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryType: DATA_PRIMARY_MCH_TYPE,
        handlePrimaryButton: () => {
            changeScreen({ screen: CardholdersScreen.INITIAL_SCREEN });
        }
    };
    const addAuthUsersFooter = {
        [CardholdersScreen.INITIAL_SCREEN]: usersLimit === '0' ? backToAccountServicesPrimary : addAuthUsersAllowed,
        [CardholdersScreen.ACCESS_DENIED_SCREEN]: backToAccountServicesPrimary,
        [CardholdersScreen.ADD_AUTH_USER]: {
            ...addAuthUsersAllowed,
            handlePrimaryButton: () => {
                if (handleAddAuthUserSubmit) {
                    handleAddAuthUserSubmit();
                }
                else {
                    triggerManageCardHoldersSamsAnalytics({
                        pageName: SAMS_PAGE_NAME.ADD_DOB
                    });
                    changeScreen({
                        screen: CardholdersScreen.ADD_AUTH_USER
                    });
                }
            },
            secondaryText: translate('button.cancel'),
            handleSecondaryButton: () => changeScreen({ screen: CardholdersScreen.INITIAL_SCREEN }),
            dataSecondaryType: 'cancel'
        },
        [CardholdersScreen.ADD_AUTH_USER_SAMS]: {
            ...addAuthUsersAllowed,
            handlePrimaryButton: () => {
                if (handleAddAuthUserSubmit) {
                    handleAddAuthUserSubmit();
                }
                else {
                    triggerManageCardHoldersSamsAnalytics({
                        pageName: SAMS_PAGE_NAME.ADD_DOB
                    });
                    changeScreen({
                        screen: CardholdersScreen.ADD_AUTH_USER_SAMS
                    });
                }
            },
            secondaryText: translate('button.cancel'),
            handleSecondaryButton: () => {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.SELECTION
                });
                changeScreen({ screen: CardholdersScreen.ADD_AUTH_USER_SAMS_LIST });
            },
            dataSecondaryType: 'cancel'
        },
        [CardholdersScreen.ERROR_SCREEN]: backToAccountServicesPrimary,
        [CardholdersScreen.CONFIRMATION_SCREEN_NEW_USER]: backToManageCardholdersPrimary,
        [CardholdersScreen.CONFIRMATION_SCREEN_EXISTING_USER]: addAuthUsersAllowed,
        [CardholdersScreen.VERIFY_USER_SCREEN]: backToAccountServicesPrimary,
        [CardholdersScreen.ADD_AUTH_USER_SAMS_LIST]: {
            ...addAuthUsersAllowed,
            handlePrimaryButton: () => {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.ADD_DOB
                });
                changeScreen({
                    screen: CardholdersScreen.ADD_AUTH_USER_SAMS
                });
            },
            primaryText: addAsAnAuthorizedUserText,
            dataPrimaryType: 'add as an authorized user'
        }
    };
    return (_jsx(FooterWrapper, { children: _jsx(Footer, { "data-testid": "cardholders-footer", ...addAuthUsersFooter[currentScreen] }) }));
};
export default CardHoldersFooter;
